// src/components/KeyValuesDashboard/components/LoadingState.tsx

import { RefreshCw } from 'lucide-react';

interface LoadingStateProps {
  mode: 'all' | 'compare';
}

export function LoadingState({ mode }: LoadingStateProps) {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-slate-200/50 p-12">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="relative mb-6">
          <div className="w-16 h-16 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-2xl flex items-center justify-center">
            <RefreshCw className="w-8 h-8 text-indigo-600 animate-spin" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl opacity-20 blur-xl" />
        </div>
        
        <h3 className="text-lg font-semibold text-slate-900 mb-2">
          Carregando análise...
        </h3>
        <p className="text-sm text-slate-600 max-w-md">
          {mode === 'all' 
            ? 'Processando dados de todos os valores disponíveis'
            : 'Carregando comparação detalhada dos valores selecionados'}
        </p>
      </div>
    </div>
  );
}

// src/components/KeyValuesDashboard/components/EmptyState.tsx

import { Database } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description: string;
}

export function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-slate-200/50 p-12">
      <div className="flex flex-col items-center justify-center text-center">
        <div className="relative mb-6">
          <div className="w-16 h-16 bg-gradient-to-br from-slate-100 to-slate-200 rounded-2xl flex items-center justify-center">
            <Database className="w-8 h-8 text-slate-400" />
          </div>
          <div className="absolute inset-0 bg-slate-300 rounded-2xl opacity-10 blur-xl" />
        </div>
        
        <h3 className="text-lg font-semibold text-slate-900 mb-2">
          {title}
        </h3>
        <p className="text-sm text-slate-600 max-w-md">
          {description}
        </p>
      </div>
    </div>
  );
}
